


















import type { PropType } from "vue"
import type { stadium_reduced_cost } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_reduced_cost> }
  },
  data() {
    return {
      data : {} as stadium_reduced_cost,
      rules: {
        save_payment    : { required: true, message: "请填写实际节省成本", trigger: "blur" },
        approval_payment: { required: true, message: "请填写节省成本收益核定", trigger: "blur" },
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.data = this.$deep_copy(this.form)
      })
    },
    submit() {
      const form = this.$refs.form as any
      const params = this.$deep_copy(this.data)
      params.estimate_id = this.id
      form.validate((valid: boolean) => {
        if (valid) this.$emit("save", params)
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  }
})

